import type React from "react";

function GridContainer(): React.ReactNode {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: initial biome migration
    <svg
      version="1.1"
      x="0px"
      y="0px"
      style={{ height: 83, opacity: 0.7, position: "absolute", bottom: -28, width: 83 }}
      width="200px"
      height="200px"
      viewBox="0 0 200 200"
      enableBackground="new 0 0 200 200"
    >
      <g>
        <path fill="#F2F6F9" d="M15.356,60.738h169.289v110.688H15.356V60.738z" />
        <path
          fill="#E0E8F1"
          d="M15.356,60.738h169.289V73.76H15.356V60.738z M28.378,155.146h143.243c7.191,0,13.023,5.832,13.023,13.023
		v3.255l0,0H15.356l0,0v-3.255C15.356,160.979,21.187,155.146,28.378,155.146z"
        />
        <path fill="#F2F6F9" d="M8.845,28.182h182.312v32.556H8.845V28.182z" />
        <path
          fill="#F9FBFC"
          d="M8.845,28.182h182.312l0,0v3.257c0,5.392-4.373,9.766-9.769,9.766H18.611c-5.394,0-9.767-4.374-9.767-9.766
		v-3.257H8.845z"
        />
        <path
          fill="#8BABCB"
          d="M184.645,25.123H15.356c-5.394,0-9.767,4.373-9.767,9.767v19.534c-0.002,4.14,2.607,7.832,6.512,9.214
		v101.471c0,5.395,4.373,9.768,9.766,9.768h156.266c5.395,0,9.766-4.373,9.766-9.768V63.638c3.904-1.382,6.517-5.074,6.513-9.214
		V34.89C194.41,29.496,190.037,25.123,184.645,25.123z M187.898,54.424c0,1.797-1.455,3.255-3.254,3.255h-13.023
		c-1.799,0-3.256,1.457-3.256,3.255c0,1.797,1.457,3.256,3.256,3.256h9.768v100.919c0,1.8-1.457,3.257-3.256,3.257H21.867
		c-1.798,0-3.255-1.457-3.255-3.257V64.19h113.943c1.799,0,3.256-1.459,3.256-3.256c0-1.799-1.457-3.255-3.256-3.255H15.356
		c-1.797,0-3.255-1.458-3.255-3.255V34.89c0-1.798,1.458-3.256,3.255-3.256h169.289c1.799,0,3.254,1.458,3.254,3.256V54.424
		L187.898,54.424z"
        />
        <path
          fill="#E0E8F1"
          stroke="#E0E8F1"
          strokeMiterlimit="10"
          d="M118.693,77.015H82.667c-5.685,0-10.293,4.609-10.293,10.293
		s4.608,10.293,10.293,10.293h36.026c5.686,0,10.295-4.609,10.295-10.293S124.379,77.015,118.693,77.015z"
        />
        <path
          fill="#8BABCB"
          d="M163.902,107.465h-26.664c-3.156,0-5.715,2.557-5.715,5.713v26.662c0,3.155,2.559,5.713,5.715,5.713h26.664
		c3.154,0,5.711-2.558,5.711-5.713v-26.662C169.613,110.021,167.057,107.465,163.902,107.465z M163.902,111.273
		c1.051,0,1.902,0.853,1.902,1.903v11.427h-13.328v-13.33H163.902z M135.336,113.178c0-1.052,0.852-1.904,1.902-1.904h11.428v13.332
		h-13.33V113.178L135.336,113.178z M137.238,141.743c-1.051,0-1.902-0.851-1.902-1.903v-11.428h13.33v13.331H137.238z
		 M165.805,139.84c0,1.053-0.852,1.903-1.902,1.903h-11.426v-13.331h13.328V139.84L165.805,139.84z"
        />
        <path
          fill="#8BABCB"
          d="M158.598,57.679h-13.021c-1.798,0-3.257,1.457-3.257,3.255c0,1.797,1.459,3.256,3.257,3.256h13.021
		c1.799,0,3.258-1.459,3.258-3.256C161.855,59.135,160.396,57.679,158.598,57.679z"
        />
      </g>
    </svg>
  );
}

export default GridContainer;
